import React, { Component } from 'react'
import { connect } from 'react-redux'
import { beautifyPrice } from 'utils/stuff'

import TextField from 'material-ui/TextField'

export default class ValidTextField extends Component {
	constructor(props) {
		super(props);
			this.state = {
				value: (this.props.value)?this.props.value:'',

			}
		}
		componentDidMount(){
			if (this.props.value) this.blur(this.props.value)
		}
		change(evt){
			if (evt.target) evt = evt.target.value;
			if ((''+evt).match(/[0-9]|\./g)){
				this.setState({value: (''+evt).match(/[0-9]|\./g).join('')});
			} else this.setState({value: ''});
		}
		blur(evt){
			if (this.props.symbol=="$"){
				let newVal, flag
	            if (newVal!=this.state.value) flag=true
				if (evt.target){
	                let value
					if (evt.target){
						value = evt.target.value.toString()
					} else {
						value = evt && evt.toString() || ''
					}

					newVal = beautifyPrice(value) || ''
					value.replace(/\D/g, '')
					newVal = beautifyPrice(value.toString()) || ''
				} else {
					if (evt) newVal = beautifyPrice(evt.toString()) || ''
				}
				if (flag) {
					if (newVal) this.setState({value: '$'+newVal})
					else this.setState({value: ''})

					if (newVal && newVal.match(/[0-9]|\./g)) {
						console.log(newVal);
						return newVal.match(/[0-9]|\./g).join('')
				}
					else return ''
				}
			}
			if (this.props.symbol=="%"){
				let newVal, flag

	            if (newVal!=this.state.value) flag=true
				if (evt.target){
	                let value = evt.target.value && evt.target.value.toString() || ''
					newVal = value.replace(/\%/g, '')
				} else {
					if (evt) newVal = evt.toString().replace(/\%/g, '')
				}
				if (flag) {
					if (newVal) this.setState({value: '$'+newVal})
					else this.setState({value: ''})
					if (newVal && newVal.match(/[0-9]|\./g)) return newVal.match(/[0-9]|\./g).join('')
					else return ''
				}
			}

		}

		render() {

			return (
				<div style={{...this.props.style}}>
					<TextField
						fullWidth={true}
						value={this.state.value}
                        name={'ValidTextField'}
						disabled={(this.props.disabled)?this.props.disabled:false}
						onChange={(evt) => {
							this.change(evt)
						}}
						onClick={(evt) => {
							this.change(evt)
						}}
						key={(this.props.key)?this.props.key:''}
						floatingLabelText={(this.props.floatingLabelText)?this.props.floatingLabelText:''}
						inputStyle={(this.props.inputStyle)?this.props.inputStyle:{fontSize: "14", color:"#000000"}}
						hintStyle={(this.props.hintStyle)?this.props.hintStyle:{fontStyle: "italic", fontSize: "14px"}}
						onBlur={(evt) => this.props.onBlur(this.blur(evt.target.value))}
						underlineStyle= {this.props.underlineStyle}
						underlineDisabledStyle= {this.props.underlineDisabledStyle}
						hintText={this.props.hintText}
						disabled={this.props.disabled}
					/>
				</div>
			)
		}
}



// WEBPACK FOOTER //
// ./src/components/validTextField.js